module.exports = __webpack_public_path__ + "img/instructor_img6.41f9110e.png";